var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$tc("Cluster", 1),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      draggable: !_vm.loading
    },
    on: {
      close: _vm.escapeClusterWindow,
      changePosition: function($event) {
        return _vm.$emit("changeClusterWindowsPosition", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [_c("ClusterSVG", { staticClass: "floating-container-svg" })]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "floating-tool-content" },
              [
                _c(
                  "div",
                  { staticClass: "cluster-objects-div" },
                  [
                    _c("cluster-selection-type-buttons", {
                      attrs: {
                        "selection-type": _vm.cluster.type
                          ? _vm.cluster.type
                          : "polygon",
                        creatable: _vm.cluster.creatable
                      },
                      on: { setType: _vm.setClusterType }
                    }),
                    _vm._v(" "),
                    _vm.cluster.creatable
                      ? _c("cluster-selected-objects", {
                          attrs: {
                            selectedObjects: _vm.clusterWKT,
                            selectionType: _vm.cluster.type
                          },
                          on: {
                            openObjectMenu: function($event) {
                              return _vm.openClusterObjectMenu(
                                $event.event,
                                $event.object
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("HighlightedBox", {
                      attrs: {
                        "bad-object": _vm.badObject,
                        "is-visible": _vm.showInstruction,
                        message: _vm.currentInstruction
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cluster.creatable
                  ? _c("cluster-fields-create", {
                      attrs: {
                        maxPathwayDistance: _vm.maxPathwayDistance,
                        maxCableLength: _vm.maxCableLength,
                        "cluster-w-k-t": _vm.clusterWKT,
                        fields: _vm.dataSaveCluster
                      },
                      on: {
                        changeValue: function($event) {
                          return _vm.changeValue($event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("home-window-button", {
              attrs: {
                label: _vm.clusterLabelButton,
                disabled: _vm.clusterButtonDisabled
              },
              on: { buttonClick: _vm.changeCluster }
            }),
            _vm._v(" "),
            _vm.clusterObjectMenu.open
              ? _c("window-object-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.closeClusterObjectMenu,
                      expression: "closeClusterObjectMenu"
                    }
                  ],
                  attrs: {
                    event: _vm.clusterObjectMenu.event,
                    object: _vm.clusterObjectMenu.object,
                    actionFrom: _vm.selectedToolObjectLayer
                  },
                  on: {
                    updateGeoServer: _vm.updateGeoServer,
                    closeMenu: _vm.closeClusterObjectMenu,
                    openForm: _vm.openFormFromClusterObjectMenu,
                    openDetailForm: function($event) {
                      return _vm.openFormFromClusterObjectMenu("detail")
                    },
                    removeFromCable: _vm.removeObjectFromCluster
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.openClosureSelection
              ? _c("cluster-closure-selection", {
                  attrs: { "closure-options": _vm.polygonClosures },
                  on: {
                    submit: _vm.previewFromClosureSelection,
                    close: function($event) {
                      _vm.openClosureSelection = false
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("app-dialog-box", {
              attrs: {
                open: _vm.clearDialog,
                title: _vm.$t("ClusterCreationClear"),
                content:
                  _vm.$t("ClusterCreationWarning") +
                  "\n\n" +
                  _vm.$t("ClusterCreationConfirmation"),
                "main-action-label": _vm.$t("No"),
                "secondary-action-label": _vm.$t("Yes")
              },
              on: {
                mainAction: function($event) {
                  _vm.clearDialog = false
                },
                secondaryAction: _vm.clearCluster
              }
            }),
            _vm._v(" "),
            _c("app-dialog-box", {
              attrs: {
                open: _vm.closeDialog,
                title: _vm.$t("ClusterCreationLeave"),
                content:
                  _vm.$t("ClusterCreationWarning") +
                  "\n\n" +
                  _vm.$t("ClusterCreationConfirmation"),
                "main-action-label": _vm.$t("No"),
                "secondary-action-label": _vm.$t("Yes")
              },
              on: {
                mainAction: function($event) {
                  _vm.closeDialog = false
                },
                secondaryAction: _vm.closeCluster
              }
            }),
            _vm._v(" "),
            _c("loading-spinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "#4fa2b7",
                height: 30,
                width: 30
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ce18a3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce18a3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Cluster/ClusterWindow.vue
// module id = null
// module chunks = 